// extracted by mini-css-extract-plugin
export var logo = "_lh-2";
export var logoWrapper = "_lh-1";
export var strip = "_lh-0";